var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStage2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 51.351,
    viewBox: "0 0 50 51.351",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1726",
    "data-name": "Rectangle 1726",
    width: 37.892,
    height: 37.378,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32118",
    "data-name": "Group 32118",
    transform: "translate(-17.547 -21.417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stage_2:_Pain_Point_Segmentation",
    "data-name": "Stage 2: Pain Point Segmentation",
    transform: "translate(17.547 21.417)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 25,
    cy: 25.676,
    rx: 25,
    ry: 25.676,
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32053",
    "data-name": "Group 32053",
    transform: "translate(3.674 2.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32052",
    "data-name": "Group 32052",
    transform: "translate(3.048 3.007)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13520",
    "data-name": "Path 13520",
    d: "M34.119,5.933l-4.635,4.66,2.327,1.861-8.9,5.413.467-.44L28.895,12.5l-2.233-1.656L32.57,4.417ZM25.482,7.286,26.3,0l2.067.973-1.508,9.02L23.868,8.485l-1.2,6.64-.157.776L22.335,5.53ZM11.2,7.26a7.3,7.3,0,0,1,8.762,5.586A7.468,7.468,0,0,1,14.5,21.8a7.3,7.3,0,0,1-8.758-5.572A7.471,7.471,0,0,1,11.2,7.262l0,0M26.495,33.389a3.705,3.705,0,0,1-1.116,1.472,4.87,4.87,0,0,1-3.105.939c-.3,0-.616-.024-.939-.054a23.255,23.255,0,0,1-5.183-1.289l-.078-.03.184-.107a3.214,3.214,0,0,0,1.126-4.342v0a3.052,3.052,0,0,0-.331-.465,2.456,2.456,0,0,1,.7.132,34.94,34.94,0,0,0,3.476.959.053.053,0,0,0,.063-.041.058.058,0,0,0-.008-.044c-.2-.338-.828-1.333-1.232-1.89-.089-.122-.182-.244-.273-.365-.137-.056-.425.211-.425.211A10.891,10.891,0,0,0,20.16,29.7c-.641-.169-1.47-.4-2.2-.66a2.988,2.988,0,0,0-1.556-.117,3.027,3.027,0,0,0-3.268-.1,36.915,36.915,0,0,1-7.272,3.448c.063,0,.144.115.217.115,1.028.685,3.287-.531,7.023-2.773a2.433,2.433,0,0,1,2.134-.178,2.561,2.561,0,0,1,.689.406,2.645,2.645,0,0,1,.579.69,2.569,2.569,0,0,1-.892,3.471l-.01.005c-.166.1-.341.2-.51.294-.2.115-.391.223-.584.338A22.9,22.9,0,0,1,9.26,36.871a14.01,14.01,0,0,1-1.463.338,10.921,10.921,0,0,1-1.74.169,7.363,7.363,0,0,1-1.539-.169,6.143,6.143,0,0,1-1.073-.328c-.134-.056-.267-.122-.4-.188a5.391,5.391,0,0,1-1.655-1.34A6.7,6.7,0,0,1,0,31.048a12.244,12.244,0,0,1,1.021-4.689A10.5,10.5,0,0,1,3.594,22.6a4.85,4.85,0,0,1,2.773-1.269,2.416,2.416,0,0,1,.561-.069h.462c.079.08.166.157.243.233a7.814,7.814,0,0,0,9.748.677,8.064,8.064,0,0,0,.828-.665c.089-.081.174-.169.258-.249h.591a2.456,2.456,0,0,1,2.018.765c.028.03.77.815,1.71,1.961.346.425.718.891,1.091,1.391A22.969,22.969,0,0,1,25.7,28.186a7.792,7.792,0,0,1,1.1,3.6,4.158,4.158,0,0,1-.311,1.6M22.348,21.025l1.1-.277,7.547-2.1-2.152-2.493,8.02-3.344,1.033,2.57-5.835,1.588L34.6,19.672Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStage2);
export default __webpack_public_path__ + "static/media/stage2.1401a02792ebe0e8dd3711b9d0d54fa6.svg";
export { ForwardRef as ReactComponent };